import defaultTheme from "./default";

import { createMuiTheme } from "@material-ui/core";

const overrides = {
    
  typography: {
      fontFamily: "Avenir Next LT Pro Regular, sans-serif",
    h1: {
      fontSize: "3rem",
    },
    h2: {
      fontSize: "2rem",
    },
    h3: {
      fontSize: "1.64rem",
    },
    h4: {
      fontSize: "1.5rem",
       fontFamily: "Avenir Next LT Pro Cn, sans-serif",
      // fontStyle: "normal"
    },
    h5: {
      fontSize: "1.285rem",
    },
    h6: {
      fontSize: "1.142rem",
    },
  },
};

export default {
  default: createMuiTheme({ ...defaultTheme, ...overrides }),
};
